module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-pale-green-018-1200x2490.f8d44052.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-pale-green-018-1200x2490.jpg
// module id = 1098
// module chunks = 37